import { LOCAL_CREDENTIALS, GET_LOCAL_CREDENTIALS, SET_USER_DETAILS, RESET, GET_LOGIN_CONFIGS } from 'fixtures/actions'

let initialState = null;

export default (state = initialState, action) => {
  switch (action.type) {
    case LOCAL_CREDENTIALS:
      return { ...state, userData: action.payload };
    case GET_LOCAL_CREDENTIALS:
      return { ...state, userData: action.payload };
    case SET_USER_DETAILS:
      return { ...state, userDetail: action.payload };
    case RESET:
      return initialState;
    case GET_LOGIN_CONFIGS:
      return { ...state, loginConfigs: action.payload };
    default:
      return state;
  }
};
